var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "col" }, [
    _c(
      "a",
      { staticClass: "video", attrs: { download: "", href: _vm.video.url } },
      [
        _c("img", {
          staticClass: "img-rounded",
          attrs: { src: _vm.video.coverphoto, alt: "" },
        }),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "videooverlay clearfix" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("span", { staticClass: "pull-right" }, [
        _vm._v(_vm._s(_vm.formatVideoDuration(_vm.video.duration))),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "pull-left" }, [
      _c("i", { staticClass: "glyphicon glyphicon-facetime-video" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }